<template>
  <b-card>
    <b-card-header>
      <h4 class="title">ویرایش کاربر</h4>
    </b-card-header>
    <b-card-body>
      <b-form @submit.prevent>
        <b-row>
          <b-col cols="4">
            <b-form-group>
              <label for="name">
                <feather-icon icon="FeatherIcon" />
                نام و نام خانوادگی
              </label>
              <b-form-input
                v-model="name"
                id="name"
                placeholder="نام و نام خانوادگی را وارد نمایید"
              />
            </b-form-group>
          </b-col>
          <b-col cols="4">
            <b-form-group>
              <label for="username">
                <feather-icon icon="UserIcon" />
                نام کاربری
              </label>
              <b-form-input
                v-model="username"
                id="username"
                autocomplete="off"
                placeholder="نام کاربری را وارد نمایید"
                :disabled="this.$store.state.user.role === 'Administrator'"
              />
            </b-form-group>
          </b-col>
          <b-col cols="4">
            <b-form-group>
              <label for="mobile">
                <feather-icon icon="SmartphoneIcon" />
                موبایل
              </label>
              <b-form-input
                v-model="mobile"
                id="mobile"
                autocomplete="off"
                placeholder="موبایل را وارد نمایید"
              />
            </b-form-group>
          </b-col>
          <b-col cols="8">
            <managed-in-dash-notice :roles="currentRoleNames" />
          </b-col>
          <b-col cols="4">
            <b-form-group>
              <label for="personnel_no">
                <feather-icon icon="PhoneCallIcon" />
                کد پرسنلی
              </label>
              <b-form-input
                v-model="personnel_no"
                id="personnel_no"
                placeholder="کد پرسنلی کاربر را وارد نمایید"
              />
            </b-form-group>
          </b-col>
          <b-col cols="4">
            <b-overlay :show="organizationList.length === 0">
              <b-form-group>
                <label for="organization_id">
                  <feather-icon icon="CheckSquareIcon" />
                  واحد سازمانی
                </label>
                <v-select
                  v-model="organization_id"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  label="name"
                  :options="organizationList"
                  :reduce="(organization) => organization.id"
                >
                </v-select>
              </b-form-group>
            </b-overlay>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label>
                <feather-icon icon="BriefcaseIcon" />
                نقش سازمانی در اتوماسیون
              </label>
              <v-select
                v-model="organization_role"
                :options="orgRoleOptions"
                label="label"
                :reduce="(role) => role.value"
                placeholder="انتخاب نقش سازمانی..."
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              />
            </b-form-group>
          </b-col>
          <b-col cols="4">
            <b-form-group label=" تاریخ تولد" label-for="birthday">
              <date-picker
                v-model="birthday"
                type="date"
                display-format="jDD jMMMM jYYYY"
                format="YYYY-MM-DD"
                clearable
              />
            </b-form-group>
          </b-col>
          <b-col cols="4">
            <b-form-group label=" تاریخ استخدام" label-for="hired_at">
              <date-picker
                v-model="hired_at"
                type="date"
                display-format="jDD jMMMM jYYYY"
                format="YYYY-MM-DD"
                clearable
              />
            </b-form-group>
          </b-col>
          <b-col cols="4">
            <b-form-group
              description="برای عدم تغییر در رمز عبور آن را خالی قرار دهید."
            >
              <label for="password">
                <feather-icon icon="LockIcon" />
                رمز عبور
              </label>
              <b-input-group>
                <b-form-input
                  :type="passwordFieldType"
                  v-model="password"
                  id="password"
                  autocomplete="off"
                  placeholder="رمز عبور را وارد نمایید"
                />
                <b-input-group-append is-text>
                  <feather-icon
                    :icon="passwordToggleIcon"
                    class="cursor-pointer"
                    @click="togglePasswordVisibility"
                  />
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col cols="4">
            <b-overlay>
              <b-form-group>
                <label for="relatedProfiles">
                  <feather-icon icon="UsersIcon" />
                  کارتابل های مرتبط
                </label>
                <b-overlay :show="!getUsersData">
                  <v-select
                    v-model="relatedProfiles"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    multiple
                    label="name"
                    :options="usersList"
                    :reduce="(user) => user.id"
                    :close-on-select="false"
                  >
                  </v-select>
                </b-overlay>
              </b-form-group>
            </b-overlay>
          </b-col>

          <b-col md="4">
            <b-form-group>
              <label></label>
              <b-form-checkbox
                checked="true"
                name="check-button"
                class="custom-control-success"
                switch
                v-model="isActive"
              >
                فعال
              </b-form-checkbox>
            </b-form-group>
          </b-col>
        </b-row>

        <hr />

        <b-row>
          <b-col cols="12" class="my-1">
            <small class="font-weight-semibold">دسترسی های نامه و وظیفه</small>
          </b-col>
          <b-col cols="4">
            <b-overlay :show="rolesList.length === 0">
              <b-form-group>
                <label for="role">
                  <feather-icon icon="UserCheckIcon" />
                  نقش
                </label>
                <v-select
                  v-model="ticketRoles"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  label="slug"
                  :options="rolesList"
                  :reduce="(role) => role.id"
                  multiple
                  :close-on-select="false"
                >
                </v-select>
              </b-form-group>
            </b-overlay>
          </b-col>
          <b-col cols="4">
            <b-overlay :show="permissionList.length === 0">
              <b-form-group>
                <label for="permissions">
                  <feather-icon icon="CheckSquareIcon" />
                  لیست دسترسی ها
                </label>
                <v-select
                  v-model="ticketPermissions"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  multiple
                  label="slug"
                  :options="permissionList"
                  :reduce="(permission) => permission.id"
                  :close-on-select="false"
                >
                </v-select>
              </b-form-group>
            </b-overlay>
          </b-col>
          <b-col cols="4">
            <b-overlay>
              <b-form-group>
                <label for="relatedUsers">
                  <feather-icon icon="LinkIcon" />
                  کاربران مرتبط
                </label>
                <v-select
                  v-model="relatedUsers"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  multiple
                  label="name"
                  :options="relatedUsersList"
                  :reduce="(user) => user.id"
                  :close-on-select="false"
                >
                </v-select>
              </b-form-group>
            </b-overlay>
          </b-col>
        </b-row>
      </b-form>
      <button class="btn btn-info mt-2" @click="updateUser">
        ویرایش کاربر
      </button>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardHeader,
  BCardBody,
  BForm,
  BFormGroup,
  BFormInput,
  BOverlay,
  BInputGroup,
  BInputGroupAppend,
  BFormCheckbox,
} from "bootstrap-vue";
import VSelect from "vue-select";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import ManagedInDashNotice from "@/views/user/components/ManagedInDashNotice.vue";

export default {
  name: "Users_Update",
  components: {
    BFormCheckbox,
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BForm,
    BFormGroup,
    BFormInput,
    VSelect,
    BOverlay,
    BInputGroup,
    BInputGroupAppend,
    ValidationProvider,
    ValidationObserver,
    ManagedInDashNotice,
  },
  data() {
    return {
      name: "",
      username: "",
      mobile: "",
      roles: [],
      rolesList: [],
      userGroupList: [],
      permissionList: [],
      relatedUsers: [],
      relatedProfiles: [],
      relatedUsersList: [],
      personnel_no: "",
      password: "",
      ticketRoles: [],
      ticketPermissions: [],
      hired_at: null,
      birthday: null,
      isActive: true,
      organizationList: [],
      organization_id: null,
      usersList: [],
      getUsersData: false,
      organization_role: null,
      orgRoleOptions: [
        { label: "مدیر (Manager)", value: "manager" },
        { label: "کاربر عادی (User)", value: "user" },
      ],
    };
  },
  mixins: [togglePasswordVisibility],
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
    // Shown read-only: roles are changed in Dash.
    currentRoleNames() {
      return this.rolesList
        .filter((role) => this.roles.includes(role.id))
        .map((role) => role.slug);
    },
  },
  methods: {
    getUser() {
      this.$http
        .get(`user/users/${this.$route.params.id}`)
        .then(({ data }) => {
          if (data.status) {
            this.user = data.user;
            this.name = data.user.name;
            this.username = data.user.username;
            this.mobile = data.user.mobile;
            this.roles = data.user.roles;
            this.personnel_no = data.user.personnel_no;
            this.relatedUsers = data.user.related;
            this.relatedUsersList = data.relatedUsers;
            this.relatedProfiles = data.user.relatedProfiles;
            this.ticketRoles = data.user.ticketRoles;
            this.ticketPermissions = data.user.ticketPermissions;
            this.hired_at = data.user.hiredAt;
            this.birthday = data.user.birthday;
            this.isActive = data.user.isActive;
            this.organization_id = data.user.organization_id;
            this.organization_role = data.user.organization_role
              ? data.user.organization_role.key
              : null;
          } else {
            this.$bvToast.toast("دریافت گروه کاربری با خطا مواجه شد", {
              title: "خطا در دریافت اطلاعات",
              toaster: "b-toaster-top-right",
              variant: "danger",
            });
          }
        })
        .catch(() => {
          this.$bvToast.toast("ارتباط با وبسرویس انجام نشد", {
            title: "خطا در دریافت اطلاعات",
            toaster: "b-toaster-top-right",
            variant: "danger",
          });
        });
    },
    updateUser() {
      if (this.name === "") {
        this.$bvToast.toast("نام و نام خانوادگی نمیتواند خالی باشد", {
          title: "خطا",
          toaster: "b-toaster-top-right",
          variant: "danger",
        });
        return false;
      }

      if (this.mobile === "") {
        this.$bvToast.toast("موبایل نمیتواند خالی باشد", {
          title: "خطا",
          toaster: "b-toaster-top-right",
          variant: "danger",
        });
        return false;
      }
      this.$http
        .put(`user/users/${this.$route.params.id}`, {
          name: this.name,
          username: this.username,
          mobile: this.mobile,
          relatedUsers: this.relatedUsers,
          relatedProfiles: this.relatedProfiles,
          ticketRoles: this.ticketRoles,
          ticketPermissions: this.ticketPermissions,
          personnel_no: this.personnel_no,
          hired_at: this.hired_at,
          birthday: this.birthday,
          password: this.password,
          is_active: this.isActive,
          organization_id: this.organization_id,
          organization_role: this.organization_role,
        })
        .then(({ data }) => {
          if (data.status) {
            this.$bvToast.toast("کاربر با موفقیت ایجاد شد", {
              title: "موفقیت",
              toaster: "b-toaster-top-right",
              variant: "success",
            });
            this.getUser();
            this.getRelatedUsers();
          } else {
            this.$bvToast.toast("در ایجاد کاربر خطایی رخ داده", {
              title: "حطا",
              toaster: "b-toaster-top-right",
              variant: "danger",
            });
          }
        })
        .catch((error) => {
          this.$bvToast.toast(error.response.data.message ?? error.message, {
            title: "خطا در دریافت اطلاعات",
            toaster: "b-toaster-top-right",
            variant: "danger",
          });
        });
    },
    getPermissions() {
      this.$http
        .get("user/permissions")
        .then(({ data }) => {
          if (data.status) {
            this.permissionList = data.permissions;
          } else {
            this.$bvToast.toast("دریافت لیست دسترسی ها با خطا مواجه شد", {
              title: "خطا در دریافت اطلاعات",
              toaster: "b-toaster-top-right",
              variant: "danger",
            });
          }
        })
        .catch(() => {
          this.$bvToast.toast("ارتباط با وبسرویس انجام نشد", {
            title: "خطا در دریافت اطلاعات",
            toaster: "b-toaster-top-right",
            variant: "danger",
          });
        });
    },
    getRoles() {
      this.$http
        .get("user/roles")
        .then(({ data }) => {
          if (data.status) {
            this.rolesList = data.roles;
          } else {
            this.$bvToast.toast("دریافت لیست نقش ها با خطا مواجه شد", {
              title: "خطا در دریافت اطلاعات",
              toaster: "b-toaster-top-right",
              variant: "danger",
            });
          }
        })
        .catch(() => {
          this.$bvToast.toast("ارتباط با وبسرویس انجام نشد", {
            title: "خطا در دریافت اطلاعات",
            toaster: "b-toaster-top-right",
            variant: "danger",
          });
        });
    },
    getRelatedUsers() {
      this.$http
        .get(`user/users/${this.$route.params.id}/related`)
        .then(({ data }) => {
          if (data.status) {
            this.relatedUsersList = data.users;
          } else {
            this.$bvToast.toast("دریافت کاربران مرتبط با خطا مواجه شد", {
              title: "خطا در دریافت اطلاعات",
              toaster: "b-toaster-top-right",
              variant: "danger",
            });
          }
        })
        .catch(() => {
          this.$bvToast.toast("ارتباط با وبسرویس انجام نشد", {
            title: "خطا در دریافت اطلاعات",
            toaster: "b-toaster-top-right",
            variant: "danger",
          });
        });
    },
    getOrganization() {
      this.$http
        .get("organizations?result=all")
        .then(({ data }) => {
          if (data.status) {
            this.organizationList = data.organizations;
          } else {
            this.$bvToast.toast("دریافت لیست نقش ها با خطا مواجه شد", {
              title: "خطا در دریافت اطلاعات",
              toaster: "b-toaster-top-right",
              variant: "danger",
            });
          }
        })
        .catch(() => {
          this.$bvToast.toast("ارتباط با وبسرویس انجام نشد", {
            title: "خطا در دریافت اطلاعات",
            toaster: "b-toaster-top-right",
            variant: "danger",
          });
        });
    },
    getUsers() {
      this.$http
        .get("user/list")
        .then(({ data }) => {
          this.usersList = data;
          this.getUsersData = true;
        })
        .catch((error) => {
          this.$bvToast.toast("ارتباط با وبسرویس انجام نشد", {
            title: "خطا در دریافت اطلاعات",
            toaster: `b-toaster-top-${
              this.$store.state.appConfig.isRTL ? "right" : "left"
            }`,
            variant: "danger",
          });
        });
    },
  },

  mounted() {
    this.getUsers();
    this.getUser();
    this.getPermissions();
    this.getRoles();
    this.getOrganization();
  },
};
</script>

<style></style>
